<template>
  <div>
    <PageAllow controller="Settings" action="logisticsApiSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card>
          <v-card-title>
            {{ $t("logisticsApiSetting.logistics_form") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("logisticsApiSetting.logistics_form_name") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="setting.push_logistics_form"
                  :items="logisticItems"
                  item-value="value"
                  item-text="text"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          class="my-5"
          v-if="setting && setting.push_logistics_form == 2002"
        >
          <v-card-title>
            {{ $t("logisticsApiSetting.kdn_form") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- EBusinessID -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("logisticsApiSetting.kdn_ebusiness_id") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="setting.push_kdn_ebusiness_id"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- AppKey -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("logisticsApiSetting.kdn_appkey") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="setting.push_kdn_appkey">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Url -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("logisticsApiSetting.kdn_url") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="setting.push_kdn_url">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 快递鸟版本 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("logisticsApiSetting.logistics_version") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="setting.push_logistics_version"
                  :items="versions"
                  item-value="value"
                  item-text="text"
                  :label="$t('Global.select')"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Settings from "@/api/settings";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("logisticsApiSetting.ext_api"),
        disabled: true,
        href: "/settings/logistics-api-setting",
      },
    ],

    logisticItems() {
      return [
        {
          text: i18n.t("Global.select"),
          value: null,
        },
        {
          text: i18n.t("logisticsApiSetting.kdn"),
          value: 2002,
        },
      ];
    },
    versions() {
      return [
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.free"),
          value: 1002,
        },
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.charge"),
          value: 8001,
        },
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.search"),
          value: 8002,
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    setting: {},
  }),

  mounted() {
    this.getSettingsFromAPI();
  },

  methods: {
    getSettingsFromAPI() {
      Settings.getSettings({
        keys: [
          "push_logistics_form",
          "push_kdn_ebusiness_id",
          "push_kdn_appkey",
          "push_kdn_url",
          "push_logistics_version",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.setting = response.data.settings;
            if (
              this.setting.distribution_district_unique_enable ||
              this.setting.distribution_district_unique_enable == 0
            ) {
              delete this.setting.distribution_district_unique_enable;
            }
          }
        }.bind(this)
      );
    },

    save() {
      Settings.kdnSave(this.setting).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("logisticsApiSetting.saveSuccess"));
            this.getSettingsFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>